export function getDateDiffFromNow(iso: string) {
  const date = new Date(iso);
  const diff = date.getTime() - Date.now();

  return Math.max(diff, 0);
}
